import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { SettingsProvider } from "@/context/SettingsContext";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";

// Layout for the dedicated SEO routes. Nav/footer links jump back to the
// matching section on the single-page home via a URL hash.
export default function Shell({ children }) {
  const navigate = useNavigate();
  const scrollToId = useCallback(
    (id) => navigate(id === "home" ? "/" : `/#${id}`),
    [navigate]
  );
  return (
    <SettingsProvider>
      <div className="bg-parchment dark:bg-ink text-foreground min-h-screen flex flex-col">
        <Navbar scrollToId={scrollToId} solid />
        <main className="flex-1 pt-20">
          {typeof children === "function" ? children(scrollToId) : children}
        </main>
        <Footer scrollToId={scrollToId} />
      </div>
    </SettingsProvider>
  );
}
